var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"membership-img-container"},[_c('div',{staticClass:"img-wrapper"},[(_vm.selectedMembership === 'mf_3month' && _vm.me.gender == 1)?_c('img',{attrs:{"src":require('@/assets/images/membership/marry-fit-female-9.png'),"alt":""}}):_c('img',{attrs:{"src":require('@/assets/images/membership/marry-fit-plus-9.png'),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }